import moment from 'moment'

export function getPhotosDateTimeBoundary(photos) {
  if (!photos || photos.length == 0) return {}

  let sortedPhotos = photos.sort(function(a, b) {
    return a.UploadedAt < b.UploadedAt ? -1 : 1
  })

  return {
    minDate: moment(sortedPhotos[0].UploadedAt).toDate(),
    maxDate: moment(sortedPhotos[sortedPhotos.length - 1].UploadedAt).toDate(),
  }
}